module.exports = __webpack_public_path__ + "static/img/1_1_1.596b0864.jpg";